import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FaRegPlayCircle } from 'react-icons/fa';
import Nav from '../components/Nav/Nav';
import Movie from '../components/Movie/Movie';
import { addMyList } from '../redux/myList';
import { getMovie } from '../redux/playMovie';

const SearchResults = () => {
  let { state } = useLocation();

  if (state === null) {
    state = 'the';
  }

  const dispatch = useDispatch();

  const topRated = useSelector((state) => state.topRated);
  const trending = useSelector((state) => state.trending);
  const action = useSelector((state) => state.action);
  const comedy = useSelector((state) => state.comedy);
  const horror = useSelector((state) => state.horror);
  const romance = useSelector((state) => state.romance);
  const animation = useSelector((state) => state.animation);
  const history = useSelector((state) => state.history);
  const tvNews = useSelector((state) => state.tvNews);
  const documentary = useSelector((state) => state.documentary);
  const crime = useSelector((state) => state.crime);
  const fantasy = useSelector((state) => state.fantasy);
  const scienceFiction = useSelector((state) => state.scienceFiction);
  const tvWarAndPolitics = useSelector((state) => state.tvWarAndPolitics);
  const thriller = useSelector((state) => state.thriller);
  const upComing = useSelector((state) => state.upComing);
  const music = useSelector((state) => state.music);

  let allMovies;

  if (Array.isArray(trending.results)) {
    allMovies = topRated.results.concat(trending.results,
      action.results, comedy.results, horror.results, romance.results,
      animation.results, history.results, tvNews.results, documentary.results,
      crime.results, fantasy.results, scienceFiction.results,
      tvWarAndPolitics.results, thriller.results, upComing.results, music.results);
  } else {
    allMovies = [];
  }
  // Remove duplicates
  const ids = allMovies.map(({ id }) => id);
  const filterList = allMovies.filter(({ id }, index) => !ids.includes(id, index + 1));
  // Remove duplicates end

  const filteredResult = filterList.filter((movie) => movie.title?.toLowerCase()
  === state.toLowerCase());

  const movie = filteredResult[0];
  const relatedMovies = filterList.filter((movie) => movie.title?.toLowerCase()
    .includes(state.toLowerCase())
  || movie.original_title?.toLowerCase().includes(state.toLowerCase()));

  const truncate = (str, n) => (
    str?.length > n ? `${str.substr(0, n - 1)}...` : str);

  const handleClick = (movie) => {
    const play = true;
    const playMovieProps = { movie, play };
    dispatch(getMovie(playMovieProps));
    dispatch(addMyList(movie));
  };

  return (
    <>
      <Nav />
      { filteredResult.length === 0 ? (
        <h3 className="movies-category search-title">
          Movie with title `
          {state}
          ` not found
        </h3>
      ) : (
        <>
          <div
            className="home-movie"
            style={{
              backgroundSize: 'cover',
              backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
              backgroundPosition: 'center center',
            }}
          >
            <div className="home-movie-contents">
              <h1 className="home-movie-title">
                {movie?.title || movie?.name || movie?.original_name}
              </h1>
              <div className="home-movie-buttons">
                <button className="home-movie-button play-btn" type="button" onClick={() => handleClick(movie)}>
                  <span>Play</span>
                  <FaRegPlayCircle />
                </button>
              </div>
              <p className="home-movie-description">
                {truncate(movie?.overview, 300)}
              </p>
            </div>
            <div className="home-movie--fadeBottom" />
          </div>
          <div />
        </>
      )}

      <div className="all-movies">

        <div className="main-movie-section flixfrenzy-originals">
          <Movie fetchUrl={relatedMovies} title="Related Results" />
        </div>

      </div>
    </>
  );
};

export default SearchResults;
